import { getProduct } from "@/lib/api/v1";
import { useOfferContext } from "@/lib/hooks/useOfferContext";
import { sanitize } from "@/lib/utils";
import {  ProductDetails } from "@vertical-insure/shared";
import { useEffect, useState } from "react";

export const ProductDetailsComponent = () => {
  const offer = useOfferContext();
  const [productDetails, setProductDetails] = useState<ProductDetails | undefined>();

  useEffect(() => {
    const loadProductDetails = async () => {
      const product = offer.config?.product_config ? Object.keys(offer.config?.product_config)[0] : undefined;
      if (product && !productDetails && offer.config) {
        const productResponse = await getProduct(offer.config.client_id!, offer.config.version, product);
        if (productResponse) {
          setProductDetails(productResponse.product);
        }
      }
    }

    loadProductDetails();
  }, [offer, productDetails])

  return productDetails ? (
    <div className="space-y-2">
      <div className="font-semibold" dangerouslySetInnerHTML={{__html: sanitize(productDetails.promotional_header)}}></div>
      <div className="text-sm" dangerouslySetInnerHTML={{__html: sanitize(productDetails.promotional_description)}}></div>
    </div>
  ) : null;
}
